import { render, staticRenderFns } from "./CollectionDownload.vue?vue&type=template&id=6b67380f&scoped=true"
import script from "./CollectionDownload.vue?vue&type=script&lang=js"
export * from "./CollectionDownload.vue?vue&type=script&lang=js"
import style0 from "./CollectionDownload.vue?vue&type=style&index=0&id=6b67380f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b67380f",
  null
  
)

export default component.exports